module.exports = __webpack_public_path__ + "static/media/arrowright.d3baf6dd.svg";